import {useEffect, useState} from 'react';
import {H2, H3, P, PNoMargin} from '@/typography';
import {useTranslations} from 'next-intl';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Row, Col, Grid} from '@/grid';
import {withMarginBottomXl, withMarginBottomXlToSm} from '@/hocs/withSpacing';
import {withBgBrownRose50} from '@/hocs/withColors';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import DetectOS from '@/utils/user-agent';
import PictureWrapper from '@/ui/images-wrapper';
import styles from './styles.module.scss';

const BrownRose50Section = withBgBrownRose50(SectionPadding);
const DivMargined = withMarginBottomXlToSm('div');
const TitleBlock = withMarginBottomXl('div');

const imgPath = '/static/images/home/support/';

const SupportSection = () => {
  const t = useTranslations('homepage.demandingBusinesses');
  const [downloadUrl, setDownloadUrl] = useState('');

  useEffect(() => {
    const os = DetectOS();
    if (os === 'android') {
      setDownloadUrl('https://play.google.com/store/apps/details?id=com.workable.ats');
    } else if (os === 'ios') {
      setDownloadUrl('https://apps.apple.com/us/app/workable/id1164841670?ls=1');
    } else {
      setDownloadUrl('https://apps.apple.com/us/app/workable/id1164841670?ls=1');
    }
  }, []);

  return (
    <BrownRose50Section>
      <Container>
        <Grid fluid>
          <Row center="xs">
            <Col xs={12} md={10}>
              <H2>{t('title')}</H2>
              <TitleBlock>
                <PNoMargin>{t('subtitle')}</PNoMargin>
              </TitleBlock>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <DivMargined>
                <GridLayout Col={3} lgCol={2} autoRows>
                  <GridItem Col={2} Row={2}>
                    <PictureWrapper
                      imgPath={imgPath}
                      imageUrl="reporting-tools"
                      imageTypeFallback="jpg"
                      altImage={t('box1.imageAlt')}
                      className={styles['reporting-tools-image']}
                    />
                  </GridItem>
                  <GridItem>
                    <BoxGrid backgroundColor="var(--brown100)">
                      <H3>{t('box1.title')}</H3>
                      <PNoMargin>{t('box1.description')}</PNoMargin>
                    </BoxGrid>
                  </GridItem>
                  <GridItem>
                    <BoxGrid
                      backgroundColor="var(--brown100)"
                      imgPath={imgPath}
                      imageUrl="Integrations"
                      imageTypeFallback="jpg"
                      altImage={t('box2.imageAlt')}
                      flipEnabled
                      minHeight={307}
                      width={376}
                      height={307}>
                      <H3>{t('box2.title')}</H3>
                      <P>{t('box2.description')}</P>
                    </BoxGrid>
                  </GridItem>

                  {/* 2nd row */}
                  <GridItem lgCol={2}>
                    <BoxGrid
                      backgroundColor="var(--teal100)"
                      Url={downloadUrl}
                      UrlCopy={t('box3.urlCopy')}>
                      <H3>{t('box3.title')}</H3>
                      <P>{t('box3.description')}</P>
                    </BoxGrid>
                  </GridItem>
                  <GridItem Col={2}>
                    <PictureWrapper
                      imgPath={imgPath}
                      imageUrl="mobile-first"
                      imageTypeFallback="jpg"
                      altImage={t('box3.imageAlt')}
                    />
                  </GridItem>

                  {/* 3rd row */}
                  <GridItem Col={2}>
                    <PictureWrapper
                      imgPath={imgPath}
                      imageUrl="best-rated"
                      imageTypeFallback="jpg"
                      altImage={t('box4.imageAlt')}
                    />
                  </GridItem>
                  <GridItem Col={1} lgCol={2}>
                    <PictureWrapper
                      imgPath={imgPath}
                      imageUrl="average-reply"
                      imageTypeFallback="jpg"
                      altImage={t('box5.imageAlt')}
                    />
                  </GridItem>
                </GridLayout>
              </DivMargined>

              {/* 4th row */}
              <GridLayout Col={2} autoRows>
                <GridItem>
                  <BoxGrid
                    imgPath={imgPath}
                    imageUrl="security"
                    imageTypeFallback="jpg"
                    altImage={t('box6.imageAlt')}
                    flipEnabled
                    width={640}
                    height={323}>
                    <H3>{t('box6.title')}</H3>
                    <P>{t('box6.description')}</P>
                  </BoxGrid>
                </GridItem>
                <GridItem>
                  <BoxGrid
                    Url="https://workable.zendesk.com/explore/dashboard/public"
                    UrlCopy={t('box7.urlCopy')}
                    target="_blank">
                    <H3>{t('box7.title')}</H3>
                    <P>{t('box7.description')}</P>
                  </BoxGrid>
                </GridItem>
                <GridItem />
              </GridLayout>
            </Col>
          </Row>
        </Grid>
      </Container>
    </BrownRose50Section>
  );
};

export default SupportSection;
